module.exports = {"client":"Client Info & Contact","num_of_passengers":"Amount of Clients","addPassenger":"Add Passengers","editPassenger":"Edit Passengers","passenger_type":"Passenger Type","first_name":"First Name","last_name":"Last Name","ticket_number":"Ticket No.","majorContact":"Major Contact","birthday":"Birthday","phone":"Phone","gender":"Gender","male":"Male","female":"Female","unknown":"Unknown","other_contact_method":"Other Contact","email":"Email","other_contact_number":"Account","zipcode":"Zip Code"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/airticket/create/client.json
// module id = kuQ7
// module chunks = 58